import React, { useEffect, useMemo, useState } from 'react';
import { SearchIcon } from 'tdesign-icons-react';
import { AutoComplete, Form, Table } from 'tdesign-react';
import { debounce } from 'lodash';
import { renderByteRate } from '@/utils/common';
import { getOrderData, getPageConfig } from '@/hooks/useTable';
import Bundle from './Bundle';

const { FormItem } = Form;

export default function Bundles({ originData, loading, extraColumns = [], getListRequest }) {
  const [data, setData] = useState([]);
  const [sort, setSort] = useState([]);

  const columns = [
    {
      colKey: 'bundleRange',
      title: 'Bundle Range',
      cell: ({ row }) => <Bundle detail={row} getListRequest={getListRequest} />,
      sorter: true,
    },
    {
      colKey: 'byteIn',
      title: '生产吞吐',
      sorter: true,
      cell: renderByteRate,
    },
    {
      colKey: 'byteOut',
      title: '消息吞吐',
      sorter: true,
      cell: renderByteRate,
    },
    ...extraColumns,
  ];

  useEffect(() => {
    setData(originData);
  }, [originData]);

  const onSearch = debounce((_, allValues) => {
    const { bundleRange = '' } = allValues;
    setData(
      originData.filter((item) => {
        const isFound = item.bundleRange.toLowerCase().includes(bundleRange.toLowerCase());
        return isFound;
      }),
    );
  }, 300);

  const options = useMemo(() => {
    return originData.map((item) => ({
      label: item.bundleRange,
      value: item.bundleRange,
    }));
  }, [originData]);

  return (
    <>
      <Form layout='inline' style={{ justifyContent: 'space-between' }} onValuesChange={onSearch}>
        <FormItem name='bundleRange'>
          <AutoComplete
            style={{ width: 260, marginBottom: 26 }}
            popupProps={{ overlayInnerStyle: { width: 'auto' } }}
            options={options}
            placeholder='请输入Bundle'
            clearable
            inputProps={{
              suffixIcon: <SearchIcon />,
            }}
          />
        </FormItem>
      </Form>

      <Table
        columns={columns}
        resizable
        maxHeight={'100vh'}
        pagination={getPageConfig(data)}
        showSortColumnBgColor
        multipleSort
        sort={sort}
        loading={loading}
        onSortChange={setSort}
        data={getOrderData(data, sort)}
      />
    </>
  );
}
